var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.275 0.535156L5.069 5.54141H0.5L3.275 0.535156Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79499 0.580795L5.97349 4.6638L4.30249 0.00854492H8.40349L8.79499 0.580795Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2367 5.54121H6.76324L9.49999 1.59546L12.2367 5.54121Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6975 0.00854492L13.034 4.6638L10.205 0.580795L10.5965 0.00854492H14.6975Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 5.54141H13.9385L15.7325 0.535156L18.5 5.54141Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98626 16.5085L8.84826 16.3405L0.668762 6.68652H5.47551L8.88651 16.2258L8.98626 16.5085Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3058 6.68652L9.50003 14.524L6.69427 6.68652H12.3058Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3312 6.68652L10.1517 16.3405L10.0137 16.501L10.1052 16.234L13.5245 6.68652H18.3312Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.f102766b81e5fd5877a7ac51b953dffa.svg";
export { ForwardRef as ReactComponent };